import React, { useState,useEffect, useContext } from "react";
import {NavLink, Route, Switch, useParams} from 'react-router-dom'
import styles from './profile.module.css'
import {HiOutlineDotsVertical} from "react-icons/hi"
import {AiOutlineLink} from 'react-icons/ai'
import {BsShieldLock,BsGrid1X2} from 'react-icons/bs'
import {RiUserStarLine,RiUserAddLine} from 'react-icons/ri'
import Listuser from "../../../components/userlist/UserList";
import Tags from "./tags";
import axios from "axios";
import { UserContext } from "../../../context/userContext";
import { toast } from "react-toastify";
import {useHistory,useRouteMatch} from 'react-router-dom'
import PostList from "./postlist";
import Vlinks from "./vlink";
import { NavIconContext } from "../../../context/NavIconContext";

const Profile=()=>{
    let  {username}  = useParams();
    const {user}=useContext(UserContext);
    const {setIconState}=useContext(NavIconContext)
    //console.log(username)
    const history = useHistory();
    let { path, url } = useRouteMatch();

    const [showMoreOption,setShowMoreOption]=useState(false);
    const[profileData,setProfileData]=useState();
    const[showFollowers,setShowFollowers]=useState(false);
    const[navState,setNavState]=useState("posts");
    const [showContent,setShowContent]=useState(false)
    const [following,setFollowing]=useState(false);

const handleFollow=()=>{




}
const handleUnFollow=()=>{

}

    




    const pcolor={color:"#7124BD"}
const apiurl = "https://vsam.me/api/api.php?request=getUserProfile"

const getProfileData=()=>{
    axios.post(apiurl,{
        "user_id":user.userid,"token":user.token,"profile":username
    }
    ).then(res=>{
        if(res.data.status===false){
            toast.warning(res.data.msg)
            history.push('/')

         }
         if(res.data.status===true){


       //console.log(res.data)
            if(res.data.owner===false){
            if(res.data.following){
                setShowContent(true);
            }else{
                if(res.data.public){
                    setShowContent(true);
                }else{
                    setShowContent(false);
                    setNavState("");
                }
            }
        }else{
            setShowContent(true)
        }
        // if(res.data.public && res.data.following){
        //         setShowContent(true)
        // }else{
        //     setShowContent(false)
        // }    

        console.log(res.data)
       setProfileData(res.data.userData[0])
       setFollowing(res.data.following)
        
    
         }
     })


}


useEffect(() => {
    getProfileData();    
    
    return () => {
        //cleanup
    }
}, [])

const handelStat=()=>{
   history.push("/");
   setIconState("stats")
}


if(profileData){
    return(<div className={styles.main}>
        {showFollowers?
        <Listuser title="Followers" backbuttonhandle={()=>setShowFollowers(false)}>
           <br/>
            {followerlist.map(e=>
                <div className={styles.listitem}>
                    <img src={e.pp}/>
                    <div className={styles.username}>{e.username}
                    <div style={{fontWeight:"300"}}>{e.name}</div>
                    </div>
                   
                    {e.follow?
                    <button className="unfollowbtn">Unfollow</button>:
                    <button className="followbtn">Follow</button>}                                        
                </div>)}
                        
            </Listuser>:""}

                       
       <div className={styles.header}>
        <div className={styles.dotsCon}><HiOutlineDotsVertical onClick={()=>setShowMoreOption(!showMoreOption)} /></div>
        {showMoreOption?
        <div className={styles.moreOption}>
            <div>Unfollow</div>
            <div>Report</div>
            <div>Block</div>
            <div>Copy Profile URL</div>
            <div>Share this Profile</div>
            

        </div>:""}




           <div className={styles.pp}>
               <img  src={profileData.Profile_Image} />
                <div style={{fontWeight:"600"}}>{profileData.username}</div>
                <div style={{fontSize:"smaller"}}>{profileData.FirstName} | Photographer</div>
                <div style={{fontSize:"large",marginBottom:"20px"}}>{profileData.Bio}
</div>
           </div>
           
           <div className={styles.fv}>
             <div className={styles.number}>
             {profileData.Profile_Visit}   
                <div className={styles.fvt}>
                    Views
                    </div>  
                                        
               </div>
               <div style={{cursor:"pointer"}} onClick={()=>setShowFollowers(true)} className={styles.number}>
                {profileData.followers?
                <>
                 {profileData.followers}</>:"0"}
                       
                <div className={styles.fvt}>
                    Followers
                    </div>  
                                        
               </div>
              {false?
               <>
               <div className={styles.followUnfollow}>
               
               <button  className={following?"unfollowbtn":"followbtn"} >{following?"Unfollow":"Follow"}</button>
               
               </div>
               <div className={styles.followUnfollow}>
               
               <button  className={"followbtn"} >Message</button>
               
               </div>
               </>:
               <>
               <div className={styles.followUnfollow}>
               
               <button className={"followbtn"}  onClick={()=>handelStat()}>Stats</button>
               
               </div>
               <div className={styles.followUnfollow}>
               <NavLink to='/setting/edit-profile'>
               <button   className={"followbtn"} >
                   Edit Profie
               </button>
               </NavLink>
               </div>
               </>}
               

           </div>
          
       </div>
      
          
       <div className={styles.navigator}>
           <div className={styles.nitem}>
               <NavLink 
               activeStyle={{color:"#7124BD"}}
               className={styles.profileLink} exact to={`${url}`} >
               <div   className={styles.nicon}><BsGrid1X2/></div>
               <div className={styles.ntxt}>Posts</div>
                    </NavLink>
           </div>
           
             <div className={styles.nitem}>
             <NavLink 
               activeStyle={{color:"#7124BD"}}
               className={styles.profileLink} to={`${url}/tags`} >
               <div className={styles.nicon}><RiUserAddLine/></div>
               <div className={styles.ntxt}>Tags</div>
               </NavLink>
               
           </div>
           <div className={styles.nitem}>
           <NavLink 
               activeStyle={{color:"#7124BD"}}
               className={styles.profileLink} to={`${url}/vlinks`} >
               <div className={styles.nicon}><AiOutlineLink/></div>
               <div className={styles.ntxt}>VLinks</div>
               </NavLink>
           </div>
           <div className={styles.nitem}>
               <div className={styles.nicon}><RiUserStarLine/></div>
               <div className={styles.ntxt}>Challenges</div>
           </div>
       </div>
      {showContent?
      <>
      <Switch>
        <Route exact path={`${path}`}>
        <PostList/>
        </Route>
        <Route exact path={`${path}/vlinks`}>
        <Vlinks/>
        </Route>

      </Switch>
      
     
       
        </>:<div className={styles.privateAcoount}>
            <BsShieldLock/>
            <div>
                <span className={styles.pvtHeading} >This Account is Private</span>
                <br/>
                <span style={{opacity:".7"}}>Follow this account to see their photos and video.</span>
            </div>
            </div>}


    </div>)}
    else{
        return(
            <div>
                Loading
            </div>
        )
    }
}





const followerlist=[
    {
        id:1,
        username:"arham_choudhary",
        pp:"https://cultivatedculture.com/wp-content/uploads/2019/12/LinkedIn-Profile-Picture-Example-Tynan-Allan.jpeg",
        follow:true,
        name:"Arham"
    },
    {
        
            id:2,
            username:"tp0078",
            pp:"https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg",
            follow:false,
            name:"Tahir"
        
    },{
        id:3,
        username:"arhamchoudhary",
        pp:"https://cultivatedculture.com/wp-content/uploads/2019/12/LinkedIn-Profile-Picture-Example-Tynan-Allan.jpeg",
        follow:true,
        name:"Arham"
    },
    {
        
            id:4,
            username:"tp0078",
            pp:"https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg",
            follow:false,
            name:"Tahir"
        
    }, {
        id:1,
        username:"arham_choudhary",
        pp:"https://cultivatedculture.com/wp-content/uploads/2019/12/LinkedIn-Profile-Picture-Example-Tynan-Allan.jpeg",
        follow:true,
        name:"Arham"
    },
    {
        
            id:2,
            username:"tp0078",
            pp:"https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg",
            follow:false,
            name:"Tahir"
        
    },{
        id:3,
        username:"arhamchoudhary",
        pp:"https://cultivatedculture.com/wp-content/uploads/2019/12/LinkedIn-Profile-Picture-Example-Tynan-Allan.jpeg",
        follow:true,
        name:"Arham"
    },
    {
        
            id:4,
            username:"tp0078",
            pp:"https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg",
            follow:false,
            name:"Tahir"
        
    }, {
        id:1,
        username:"arham_choudhary",
        pp:"https://cultivatedculture.com/wp-content/uploads/2019/12/LinkedIn-Profile-Picture-Example-Tynan-Allan.jpeg",
        follow:true,
        name:"Arham"
    },
    {
        
            id:2,
            username:"tp0078",
            pp:"https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg",
            follow:false,
            name:"Tahir"
        
    },{
        id:3,
        username:"arhamchoudhary",
        pp:"https://cultivatedculture.com/wp-content/uploads/2019/12/LinkedIn-Profile-Picture-Example-Tynan-Allan.jpeg",
        follow:true,
        name:"Arham"
    },
    {
        
            id:4,
            username:"tp0078",
            pp:"https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg",
            follow:false,
            name:"Tahir"
        
    }

]





export default Profile